import React, { useState } from "react";
import Icon from "../../_default/Icon";
import Input from "../../_default/Input";
import { Draggable } from "react-beautiful-dnd";
import "./Plan.scss";

export default function Food({ item, idx, isAdmin, removeExercise, onChange }) {
  console.log("items  ",item,isAdmin)
  const quantityOnChange=(e,idx)=>{
    debugger
    onChange(e, "quantity", idx)
  }
  return (
    <Draggable draggableId={item.mealplan_id} key={item.mealplan_id} index={idx}>
      {(provided, snapshot) => (
        <div className={`c-set-item c-set-mealplan ${snapshot.isDragging ? "--ondrag" : ""}`} isDragging={snapshot.isDragging} ref={provided.innerRef} {...provided.draggableProps}>
          <div className="c-set-mealplan-content">
            <div className="c-set-mealplan-tile">
            <div className="c-nutrition-img" style={ { backgroundImage: 'url('+item.thumbnail+')'}}></div>
              {isAdmin ? (
                <Input label="Search Meal Component" placeholder="Name Nutrition" type="search-food" value={item.name} onClick={(e) => onChange(e, "add_food", idx)} onChange={(e) => onChange(e, "name", idx)} />
              ) : (
                <div className="c-coach-pills-wrapper">
                  <span>Nutrition</span>
                  <p>{item.name}</p>
                </div>
              )}
              <div className="c-set-mealplan-title-amount">
                {isAdmin ? (
                  // <Input type="number"  label="Portion (gram/ml)" placeholder="100g" value={item.quantity===1?item.quantity-1:item.quantity} onChange={(e) => {onChange(e, "quantity", idx)}} />
                  <Input type="number"  label="Portion (gram/ml)" placeholder="100g" value={item.quantity===1?"":item.quantity} onChange={(e)=>{quantityOnChange(e,idx)}} />
                // <input type="text" placeholder="100g" value={item.quantity}  onChange={(e) => {onChange(e, "quantity", idx)}}/>
                  ) : (
                  <div className="c-coach-pills-wrapper">
                    <span>Portion in gram</span>
                    <p>{item.quantity}</p>
                  </div>
                )}
              </div>
            </div>
            <div className="c-set-reps">
              {isAdmin ? (
                <>
                  <Input type="number" placeholder="0" min={0} label="Protein" value={item.protein} onChange={(e) => onChange(e, "protein", idx)} />
                  {/* <input type="number" min={0} /> */}
                  <Input type="number" placeholder="0" min={0} label="Fat" value={item.fats} onChange={(e) => onChange(e, "fats", idx)} />
                  <Input type="number" placeholder="0" min={0} label="Carbohydrate" value={item.carbs} onChange={(e) => onChange(e, "carbs", idx)} />
                  <Input type="number" placeholder="0" min={0} label="Alcohol" value={item.alcohol} onChange={(e) => onChange(e, "alcohol", idx)} />
                  <Input type="number" placeholder="0" min={0} label="Fiber" value={item.fiber} onChange={(e) => onChange(e, "fiber", idx)} />
                  <Input type="number" placeholder="0" min={0} label="Calories" value={item.calories} onChange={(e) => onChange(e, "calories", idx)} />
                </>
              ) : (
                <>
                  <div className="c-coach-pills-wrapper">
                    <span>Protein</span>
                    <p>{item.protein}</p>
                  </div>
                  <div className="c-coach-pills-wrapper">
                    <span>Fat</span>
                    <p>{item.fats}</p>
                  </div>
                  <div className="c-coach-pills-wrapper">
                    <span>Carbohydrate</span>
                    <p>{item.carbs}</p>
                  </div>
                  <div className="c-coach-pills-wrapper">
                    <span>Alcohol</span>
                    <p>{item.alcohol}</p>
                  </div>
                  <div className="c-coach-pills-wrapper">
                    <span>Fiber</span>
                    <p>{item.fiber}</p>
                  </div>
                  <div className="c-coach-pills-wrapper">
                    <span>Calories</span>
                    <p>{item.calories}</p>
                  </div>
                </>
              )}
            </div>
          </div>
          {isAdmin && (
            <>
              <div className="c-move-icon" {...provided.dragHandleProps}>
                <Icon icon="move" />
              </div>
              <div className="c-trash-icon" onClick={() => removeExercise(idx)}>
                <Icon icon="trash" size={16} />
              </div>
            </>
          )}
        </div>
      )}
    </Draggable>
  );
}
